import { render } from "./OpcoesDownloadComponent.vue?vue&type=template&id=7f063f00&scoped=true"
import script from "./OpcoesDownloadComponent.vue?vue&type=script&lang=js"
export * from "./OpcoesDownloadComponent.vue?vue&type=script&lang=js"

import "./OpcoesDownloadComponent.vue?vue&type=style&index=0&id=7f063f00&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f063f00"]])

export default __exports__